<template>
    <canvas ref="linechart" style="width:100% !important; height: 380px !important;"></canvas>
</template>
<script>
import { Chart } from 'chart.js';
export default ({
    mounted(){
        this.initLine()
    },
    props:{
        label:{
            type:Array,
            default (){
                return ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange']
            }
        },
        data:{
            type:Array,
            default (){
                return [12, 19, 3, 5, 2, 3]
            }
        },
        background:{
            type:Array,
            default (){
                return [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255, 206, 86, 1)',
                    'rgba(75, 192, 192, 1)',
                    'rgba(153, 102, 255, 1)',
                    'rgba(255, 159, 64, 1)'
                ]
            }
        },
        border:{
            type:Array,
            default (){
                return [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255, 206, 86, 1)',
                    'rgba(75, 192, 192, 1)',
                    'rgba(153, 102, 255, 1)',
                    'rgba(255, 159, 64, 1)'
                ]
            }
        },
    },
    watch:{
        'data':function(){
            console.log('line chart data updated')
            this.initLine()
        }
    },
    methods:{
        initLine() {
            var ctx = this.$refs.linechart;
            var myChart = new Chart(ctx, {
                type: 'line',
                data: {
                    labels: this.label,
                    datasets: [{
                        label: 'Grafik Penjualan',
                        data: this.data,
                        fill: false,
                        borderColor: 'rgb(75, 192, 192)',
                        tension: 0.1
                    }]
                },
                // data: {
                //     labels: this.label,
                //     datasets: [{
                //         label: '# of Votes',
                //         data: this.data,
                //         backgroundColor: this.background,
                //         borderColor:this.border, 
                //         borderWidth: 1
                //     }]
                // },
                options: {
                    scales: {
                        y: {
                            beginAtZero: true
                        }
                    }
                }
            });
        }
    }
})
</script>
